"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardDeckConsumer = exports.useStandardDeck = void 0;
var react_1 = __importStar(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var helpers_1 = require("../../helpers");
var hooks_1 = require("../../hooks");
var filterCards_1 = __importDefault(require("./filterCards"));
var filterNotes_1 = __importDefault(require("./filterNotes"));
var FirebaseProvider_1 = require("../FirebaseProvider");
var UserProvider_1 = require("../UserProvider");
var _a = __read(helpers_1.createContext(), 3), hook = _a[0], Provider = _a[1], Consumer = _a[2];
var SET_FILTER_CATEGORY = 'SET_FILTER_CATEGORY';
var SET_FILTER_NEW = 'SET_FILTER_NEW';
var SET_FILTER_RETIRED = 'SET_FILTER_RETIRED';
var SET_FILTER_STARRED = 'SET_FILTER_STARRED';
var SET_FILTER_SUBCATEGORIES = 'SET_FILTER_SUBCATEGORIES';
var SET_ORDER_CARDS_BY = 'SET_ORDER_CARDS_BY';
var SET_NOTES_CARDS_BY = 'SET_ORDER_NOTES_BY';
var ADD_RECENTLY_DELETED_CARD = 'ADD_RECENTLY_DELETED_CARD';
function reducer(state, action) {
    switch (action.type) {
        case SET_FILTER_CATEGORY:
            return __assign(__assign({}, state), { filterCategory: action.category });
        case SET_FILTER_NEW:
            return __assign(__assign({}, state), { filterNew: action.value });
        case SET_FILTER_RETIRED:
            return __assign(__assign({}, state), { filterRetired: action.value });
        case SET_FILTER_STARRED:
            return __assign(__assign({}, state), { filterStarred: action.value });
        case SET_FILTER_SUBCATEGORIES:
            return __assign(__assign({}, state), { filterSubcategories: action.subcategories });
        case SET_ORDER_CARDS_BY:
            return __assign(__assign({}, state), { orderCardsBy: action.orderBy, orderCards: action.order });
        case SET_NOTES_CARDS_BY:
            return __assign(__assign({}, state), { orderNotesBy: action.orderBy, orderNotes: action.order });
        case ADD_RECENTLY_DELETED_CARD:
            return __assign(__assign({}, state), { recentlyDeletedCards: __spread(state.recentlyDeletedCards, [action.cardId]) });
        default:
            throw new Error();
    }
}
var DeckProvider = function (_a) {
    var children = _a.children, deckProp = _a.deck, userId = _a.userId;
    var deckNotes = [];
    var user = UserProvider_1.useUser();
    if (user.notes) {
        user.notes.forEach(function (note) {
            var deckNote = deckProp.notes.find(function (_a) {
                var id = _a.id;
                return id === note.id;
            });
            if (deckNote) {
                deckNotes.push(__assign(__assign(__assign({}, note), deckNote), { content: deckNote.contentEdited ? deckNote.content : note.content }));
            }
        });
    }
    var deck = __assign(__assign({}, deckProp), { notes: deckNotes });
    var db = FirebaseProvider_1.useFirebase().db;
    var api = hooks_1.useDeckApi(deck);
    var _b = __read(react_1.useReducer(reducer, {
        filterCategory: null,
        filterNew: false,
        filterRetired: false,
        filterStarred: false,
        filterSubcategories: [],
        recentlyDeletedCards: [],
        orderCards: 'desc',
        orderCardsBy: 'createdAt',
        orderNotes: 'desc',
        orderNotesBy: 'createdAt',
    }), 2), state = _b[0], dispatch = _b[1];
    var createDeckRef = react_1.useCallback(function (uid, deckId) {
        return db.collection('users').doc(uid).collection('decks').doc(deckId);
    }, [db]);
    var deckRef = createDeckRef(userId, deck.id);
    var getCard = react_1.useCallback(function (cardId) {
        return deck.cards.find(function (_a) {
            var id = _a.id;
            return id === cardId;
        });
    }, [deck.cards]);
    var getNote = react_1.useCallback(function (noteId) {
        if (deck.notes) {
            return deck.notes.find(function (_a) {
                var id = _a.id;
                return id === noteId;
            });
        }
        return null;
    }, [deck.notes]);
    var hasRole = react_1.useCallback(function (role) {
        return deck.roles.includes(role);
    }, [deck.roles]);
    var filterRecentlyDeletedCards = react_1.useCallback(function (cards) {
        return cards.filter(function (_a) {
            var id = _a.id;
            return !state.recentlyDeletedCards.includes(id);
        });
    }, [state.recentlyDeletedCards]);
    var filterCards = react_1.useCallback(function (cards) {
        if (cards === void 0) { cards = filterRecentlyDeletedCards(deck.cards); }
        return filterCards_1.default(cards, {
            category: state.filterCategory,
            new: state.filterNew,
            retired: state.filterRetired,
            starred: state.filterStarred,
            subcategories: state.filterSubcategories,
        }, {
            order: state.orderCards,
            orderBy: state.orderCardsBy,
        });
    }, [
        filterRecentlyDeletedCards,
        deck.cards,
        state.filterCategory,
        state.filterNew,
        state.filterRetired,
        state.filterStarred,
        state.filterSubcategories,
        state.orderCards,
        state.orderCardsBy,
    ]);
    var filteredCards = filterCards();
    var sortCards = react_1.useCallback(function (orderBy) {
        var order = 'desc';
        if (state.orderCardsBy === orderBy) {
            order = state.orderCards === 'desc' ? 'asc' : 'desc';
        }
        dispatch({ type: 'SET_ORDER_CARDS_BY', orderBy: orderBy, order: order });
    }, [state.orderCards, state.orderCardsBy]);
    var filterNotes = react_1.useCallback(function (notes) {
        if (notes === void 0) { notes = user.notes; }
        var deckNotes = [];
        notes.forEach(function (note) {
            var deckNote = deck.notes.find(function (_a) {
                var id = _a.id;
                return id === note.id;
            });
            if (deckNote) {
                deckNotes.push(__assign(__assign(__assign({}, note), deckNote), { content: deckNote.contentEdited ? deckNote.content : note.content }));
            }
        });
        return filterNotes_1.default(deckNotes, {
            category: state.filterCategory,
            starred: state.filterStarred,
            subcategories: state.filterSubcategories,
        }, {
            order: state.orderNotes,
            orderBy: state.orderNotesBy,
        });
    }, [
        deck.notes,
        state.filterCategory,
        state.filterStarred,
        state.filterSubcategories,
        state.orderNotes,
        state.orderNotesBy,
        user.notes,
    ]);
    var filteredNotes = filterNotes();
    var sortNotes = react_1.useCallback(function (orderBy, order) {
        var toggledOrder = order || 'desc';
        if (!order && state.orderNotesBy === orderBy) {
            toggledOrder = state.orderNotes === 'desc' ? 'asc' : 'desc';
        }
        dispatch({ type: 'SET_ORDER_NOTES_BY', orderBy: orderBy, order: toggledOrder });
    }, [state.orderNotes, state.orderNotesBy]);
    var dueCount = filteredCards.filter(function (_a) {
        var retired = _a.retired, nextReview = _a.nextReview;
        return (dayjs_1.default(helpers_1.toDate(nextReview)).isSame(new Date(), 'day') ||
            helpers_1.toDate(nextReview) < new Date()) &&
            (!retired || state.filterRetired);
    }).length;
    /**
     * Sets category by which to filter cards.
     */
    var setFilterCategory = react_1.useCallback(function (category) {
        dispatch({ type: SET_FILTER_CATEGORY, category: category });
    }, []);
    /**
     * Sets category by which to filter cards.
     */
    var toggleFilterCategory = react_1.useCallback(function (category) {
        setFilterCategory(state.filterCategory === category ? null : category);
    }, [setFilterCategory, state.filterCategory]);
    /**
     * Sets subcategories by which to filter cards.
     */
    var setFilterSubcategories = react_1.useCallback(function (subcategories) {
        dispatch({ type: SET_FILTER_SUBCATEGORIES, subcategories: subcategories });
    }, []);
    /**
     * Sets subcategories by which to filter cards.
     */
    var toggleFilterSubcategory = react_1.useCallback(function (subcategory) {
        var isCurrentlyFiltered = state.filterSubcategories.includes(subcategory);
        var newFilterSubcategories = isCurrentlyFiltered
            ? state.filterSubcategories.filter(function (filter) { return filter !== subcategory; })
            : __spread(state.filterSubcategories, [subcategory]);
        setFilterSubcategories(newFilterSubcategories);
    }, [setFilterSubcategories, state.filterSubcategories]);
    /**
     * Toggles the new filter.
     */
    var toggleFilterNew = react_1.useCallback(function (value) {
        if (value === void 0) { value = !state.filterNew; }
        dispatch({ type: SET_FILTER_NEW, value: value });
    }, [state.filterNew]);
    /**
     * Toggles the retired filter.
     */
    var toggleFilterRetired = react_1.useCallback(function (value) {
        if (value === void 0) { value = !state.filterRetired; }
        dispatch({ type: SET_FILTER_RETIRED, value: value });
    }, [state.filterRetired]);
    /**
     * Toggles the starred filter.
     */
    var toggleFilterStarred = react_1.useCallback(function (value) {
        if (value === void 0) { value = !state.filterStarred; }
        dispatch({ type: SET_FILTER_STARRED, value: value });
    }, [state.filterStarred]);
    /**
     * Calculates the proficiency percentage
     * of a category based on its cards.
     */
    var categoryProficiency = react_1.useCallback(function (category) {
        var categoryCards = filterCards_1.default(filterRecentlyDeletedCards(deck.cards), {
            category: category,
        });
        var proficiency = categoryCards.reduce(function (total, card) {
            return total + helpers_1.calculateProficiencyPercentage(card.proficiency || 0);
        }, 0);
        if (categoryCards.length) {
            proficiency /= categoryCards.length;
        }
        return proficiency;
    }, [deck.cards, filterRecentlyDeletedCards]);
    /**
     * Calculates the proficiency percentage
     * of a subcategory based on its cards.
     */
    var subcategoryProficiency = react_1.useCallback(function (subcategory) {
        var subcategoryCards = filterCards_1.default(filterRecentlyDeletedCards(deck.cards), {
            subcategories: [subcategory],
        });
        var proficiency = subcategoryCards.reduce(function (total, card) {
            return total + helpers_1.calculateProficiencyPercentage(card.proficiency || 0);
        }, 0);
        if (subcategoryCards.length) {
            proficiency /= subcategoryCards.length;
        }
        return proficiency;
    }, [deck.cards, filterRecentlyDeletedCards]);
    var toggleCardStarred = react_1.useCallback(function (cardId) {
        var card = getCard(cardId);
        if (card) {
            api.toggleCardStarred(card);
        }
    }, [api, getCard]);
    var toggleNoteStarred = react_1.useCallback(function (noteId) {
        var note = getNote(noteId);
        if (note) {
            api.toggleNoteStarred(note);
        }
    }, [api, getNote]);
    var rateCard = react_1.useCallback(function (cardId, rating, currentProgress) {
        var card = getCard(cardId);
        if (card) {
            api.rateCard(card, rating, currentProgress);
        }
    }, [api, getCard]);
    return (react_1.default.createElement(Provider, { value: __assign(__assign(__assign(__assign({}, api), deck), state), { cards: filterRecentlyDeletedCards(deck.cards), categories: deck.categories.sort(), subcategories: deck.subcategories.sort(), card: getCard, categoryProficiency: categoryProficiency,
            dueCount: dueCount,
            filterCards: filterCards,
            filterNotes: filterNotes,
            filteredCards: filteredCards,
            filteredNotes: filteredNotes,
            getCard: getCard,
            getNote: getNote,
            hasRole: hasRole,
            rateCard: rateCard, ref: deckRef, setFilterCategory: setFilterCategory,
            setFilterSubcategories: setFilterSubcategories,
            sortCards: sortCards,
            sortNotes: sortNotes,
            subcategoryProficiency: subcategoryProficiency,
            toggleCardStarred: toggleCardStarred,
            toggleFilterCategory: toggleFilterCategory,
            toggleFilterNew: toggleFilterNew,
            toggleFilterRetired: toggleFilterRetired,
            toggleFilterStarred: toggleFilterStarred,
            toggleFilterSubcategory: toggleFilterSubcategory,
            toggleNoteStarred: toggleNoteStarred }) }, children));
};
exports.useStandardDeck = hook;
exports.StandardDeckConsumer = Consumer;
exports.default = DeckProvider;
//# sourceMappingURL=StandardDeckProvider.js.map